import { isLocalFilePath } from '../constants/fileUrlAccess';
export const ONBOARDING_WEBSITE_URL_ERROR = 'Enter a valid URL (e.g. yoursite.com)';
/** Validate before adding HTTPS; the URL parser alone accepts typo schemes as hosts. */
export function normalizeOnboardingWebsiteUrl(value) {
    const trimmed = value.trim();
    if (!trimmed || /[\s\\]/.test(trimmed) || isLocalFilePath(trimmed))
        return null;
    // URL() repairs extra slashes. Ask the person to correct the address instead.
    if (/^https?:\/\/\//i.test(trimmed))
        return null;
    const normalized = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    try {
        const url = new URL(normalized);
        if (url.username || url.password)
            return null;
        const host = url.hostname.replace(/\.$/, '');
        // Public domains, local development domains, IPs and localhost are usable
        // website targets. A single label such as "ttps" is not a public domain.
        if (host !== 'localhost' && !host.includes('.') && !host.startsWith('['))
            return null;
        if (!host || host.split('.').some((part) => !part))
            return null;
        return normalized;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=onboardingWebsiteUrl.js.map